<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="6" xl="4" class="mx-auto mt-15">
          <v-card class="transparent" flat>
            <v-card-text class="text-center">
              <v-avatar size="140" color="error">
                <v-icon color="white" size="80"
                  >mdi-close-network-outline</v-icon
                >
              </v-avatar>
              <div class="text-center">
                <h1 class="mt-8 mb-4">Permission Denied !</h1>

                <h2 class="font-weight-medium subtitle-1">
                  You don’t currently have
                  <span class="font-weight-bold">enough permission</span> to
                  access this feature. As your current subscripttion plan is {{ this.getPackageLimition.package_name }}.
                  Please upgradte it.
                  <!-- <span class="font-weight-bold error--text"
                    >
                    <v-icon color="error">mdi-contacts-outline</v-icon>
                    Administrator</span
                  >
                  to permanetly get access to this feature. -->
                </h2>
                <v-btn
                  depressed
                  color="error"
                  class="mt-10 mb-2"
                  large
                  :to="{ name: 'payment' }"
                  ><v-icon left>mdi-view-dashboard-outline</v-icon> 
                  Upgrade</v-btn
                >
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
    export default {
        created(){
            // this.moduleName = this.$router.currentRoute.params.module
        },
        data(){
            return {
                moduleName:''
            }
        },
        computed:{
        ...mapGetters('auth',[
            "getPackageLimition"
            ])
        }
    }
</script>

<style lang="scss" scoped>

</style>